import { parseBarLines } from "./parse";

interface BarDistributionProps {
  content: string;
}

export function BarDistribution({ content }: BarDistributionProps) {
  const bars = parseBarLines(content);
  if (bars.length === 0) return null;

  const maxValue = Math.max(...bars.map((b) => b.value));

  return (
    <div className="cx-bar-dist">
      {bars.map((bar, i) => (
        <div key={i} className="cx-bar-row">
          <span className="cx-bar-label">{bar.label}</span>
          <div className="cx-bar-track">
            <div
              className="cx-bar-fill"
              style={{
                width: `${(bar.value / maxValue) * 100}%`,
                opacity: 1 - i * 0.15,
              }}
            />
          </div>
          <span className="cx-bar-value">{bar.value.toLocaleString()}</span>
        </div>
      ))}
    </div>
  );
}
